import React, { useState, useEffect } from 'react';
import Navbar from './Navbar'
import './Algorithms.css'
import { Link } from 'react-router-dom'
import { auth, database } from './firebase';

function Puzzles() {

  const [loggedIn, setLoggedIn] = useState(false);
  const [userQuestions, setUserQuestions] = useState([]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setLoggedIn(true);
        fetchUserQuestions(user.uid);
      } else {
        setLoggedIn(false);
      }
    });

    return unsubscribe()
  }, [auth]);

  const fetchUserQuestions = (userId) => {
    const userRef = database.ref('users').child(userId).child('questions');
    userRef.on('value', (snapshot) => {
      const questionsData = snapshot.val();
      if (questionsData) {
        const questionsArray = Object.values(questionsData);
        setUserQuestions(questionsArray);
      }
    });
  };

  return (
    <div className='algorithms-container'>
        <Navbar />
        {loggedIn ? (
        <div>
          <div className='algo_tb'>
              <p>Problem</p>
              <p>Difficulty</p>
          </div>
          <div className='prob_diff'>
              <div className='algorithms'>
                  <Link to='/problems/word-search' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Word Search Puzzle') ? 'submitted' : ''}`}>Word Search Puzzle</p>
                  </Link>
                  <Link to='/problems/crossword' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Crossword Puzzle Solver') ? 'submitted' : ''}`}>Crossword Puzzle Solver</p>
                  </Link>
                  <Link to='/problems/sliding-tile' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Sliding Tile Puzzle Solver') ? 'submitted' : ''}`}>Sliding Tile Puzzle Solver</p>
                  </Link>
                  <Link to='/problems/nonogram' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Nonogram Solver') ? 'submitted' : ''}`}>Nonogram Solver</p>
                  </Link>
                  <Link to='/problems/sokoban' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Sokoban Solver') ? 'submitted' : ''}`}>Sokoban Solver</p>
                  </Link>
                  <Link to='/problems/minesweeper' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Minesweeper Game Generator') ? 'submitted' : ''}`}>Minesweeper Game Generator</p>
                  </Link>
                  <Link to='/problems/kenken' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'KenKen Puzzle Solver') ? 'submitted' : ''}`}>KenKen Puzzle Solver</p>
                  </Link>
                  <Link to='/problems/tower-of-hanoi' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Tower of Hanoi with Peg Restrictions') ? 'submitted' : ''}`}>Tower of Hanoi with Peg Restrictions</p>
                  </Link>
                  <Link to='/problems/rubiks-cube' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === "Rubik's Cube Pattern Generator") ? 'submitted' : ''}`}>Rubik's Cube Pattern Generator</p>
                  </Link>
                  <Link to='/problems/nurikabe' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Nurikabe Puzzle Solver') ? 'submitted' : ''}`}>Nurikabe Puzzle Solver</p>
                  </Link>
              </div>
              <div className='diff'>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Medium</p>
                  <p>Medium</p>
                  <p>Medium</p>
                  <p>Hard</p>
                  <p>Hard</p>
              </div>
          </div>
        </div>
        ) : (
          <div>
            <h2>Please sign up/login to see this page</h2>
          </div>
        )}
    </div>
  )
}

export default Puzzles